<div class="row" style="--bs-gutter-x: 0">
  <div class="col-md-2"></div>
  <div class="col-md-8">
    <ng-container *ngIf="languageService.selectedLanguage === 'en'; else rodoNotEn">
      <h2>GDPR Information Clause</h2><br>
      Last updated: 23 July 2026.<br>
      <br>

      <b>1. Data controller</b><br>
      The data controller is:<br>
      <b>Sibrica</b><br>
      ul. Mieczykowa 7/16, 30-389 Krakow, Poland<br>
      e-mail: <a href="mailto:privacy@sibrica.com">privacy@sibrica.com</a><br>

      <br>
      <b>2. Purposes of processing</b><br>
      Personal data may be processed for the purpose of:<br>
      - handling enquiries and contact with clients,<br>
      - preparing and delivering IT services,<br>
      - ensuring the security and proper operation of the website,<br>
      - establishing, pursuing, or defending legal claims,<br>
      - analyzing website traffic after analytics cookie consent is granted.<br>

      <br>
      <b>3. Legal bases</b><br>
      The legal bases for data processing are Article 6(1)(a), (b) and (f) of the GDPR.<br>

      <br>
      <b>4. Categories of data</b><br>
      We may process identification data, contact data, and technical data such as server logs, IP address, and browser information.<br>

      <br>
      <b>5. Data recipients</b><br>
      Data recipients may include entities supporting IT infrastructure, hosting, and website security, solely to the extent necessary to fulfill the processing purposes.<br>
      For website traffic analysis we use Google Analytics (Google Ireland Ltd.); as a result, data may be transferred outside the European Economic Area (EEA) on the basis of the safeguards provided for in the GDPR.<br>

      <br>
      <b>6. Retention period</b><br>
      Data is stored for the period necessary to fulfill the processing purpose, and then for the period resulting from applicable law or until claims become time-barred.<br>

      <br>
      <b>7. Data subject rights</b><br>
      You have the right to access your data, rectify it, erase it, restrict processing, object, and lodge a complaint with the President of the Personal Data Protection Office.<br>

      <br>
      <b>8. Contact</b><br>
      For matters related to personal data processing, contact us at: <a href="mailto:privacy@sibrica.com">privacy@sibrica.com</a>.<br>

      <br>
      Details about cookies can be found in the <a routerLink="/polityka">Privacy Policy</a>.<br>
      <br>
    </ng-container>

    <ng-template #rodoNotEn>
    <ng-container *ngIf="languageService.selectedLanguage === 'de'; else rodoPl">
    <h2>DSGVO-Informationsklausel</h2><br>
    Zuletzt aktualisiert: 23. Juli 2026.<br>
    <br>

    <b>1. Verantwortlicher</b><br>
    Verantwortlicher für die Datenverarbeitung ist:<br>
    <b>Sibrica</b><br>
    ul. Mieczykowa 7/16, 30-389 Krakau, Polen<br>
    E-Mail: <a href="mailto:privacy@sibrica.com">privacy@sibrica.com</a><br>

    <br>
    <b>2. Zwecke der Verarbeitung</b><br>
    Personenbezogene Daten können zu folgenden Zwecken verarbeitet werden:<br>
    - Bearbeitung von Anfragen und Kontakt mit Kunden,<br>
    - Vorbereitung und Erbringung von IT-Dienstleistungen,<br>
    - Gewährleistung der Sicherheit und des ordnungsgemäßen Betriebs der Website,<br>
    - Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen,<br>
    - Analyse des Website-Verkehrs nach Erteilung der Einwilligung in Analyse-Cookies.<br>

    <br>
    <b>3. Rechtsgrundlagen</b><br>
    Die Rechtsgrundlagen der Datenverarbeitung sind Art. 6 Abs. 1 lit. a, b und f DSGVO.<br>

    <br>
    <b>4. Kategorien von Daten</b><br>
    Wir können Identifikationsdaten, Kontaktdaten und technische Daten wie Serverprotokolle, IP-Adresse und Browserinformationen verarbeiten.<br>

    <br>
    <b>5. Empfänger der Daten</b><br>
    Empfänger der Daten können Stellen sein, die die IT-Infrastruktur, das Hosting und die Sicherheit der Website unterstützen, und zwar nur in dem Umfang, der zur Erfüllung der Verarbeitungszwecke erforderlich ist.<br>
    Zur Analyse des Website-Verkehrs verwenden wir Google Analytics (Google Ireland Ltd.); dadurch können Daten auf Grundlage der in der DSGVO vorgesehenen Garantien außerhalb des Europäischen Wirtschaftsraums (EWR) übermittelt werden.<br>

    <br>
    <b>6. Speicherdauer</b><br>
    Die Daten werden für den zur Erfüllung des Verarbeitungszwecks erforderlichen Zeitraum gespeichert und anschließend für den sich aus den geltenden Rechtsvorschriften ergebenden Zeitraum oder bis zur Verjährung der Ansprüche.<br>

    <br>
    <b>7. Rechte der betroffenen Person</b><br>
    Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Widerspruch sowie das Recht, eine Beschwerde beim Präsidenten des Amtes für den Schutz personenbezogener Daten (UODO) einzureichen.<br>

    <br>
    <b>8. Kontakt</b><br>
    In Angelegenheiten der Verarbeitung personenbezogener Daten kontaktieren Sie uns unter: <a href="mailto:privacy@sibrica.com">privacy@sibrica.com</a>.<br>

    <br>
    Einzelheiten zu Cookies finden Sie in der <a routerLink="/polityka">Datenschutzerklärung</a>.<br>
    <br>
    </ng-container>

    <ng-template #rodoPl>
    <h2>Klauzula informacyjna RODO</h2><br>
    Ostatnia aktualizacja: 23 lipca 2026 r.<br>
    <br>

    <b>1. Administrator danych</b><br>
    Administratorem danych osobowych jest:<br>
    <b>Sibrica</b><br>
    ul. Mieczykowa 7/16, 30-389 Kraków<br>
    e-mail: <a href="mailto:privacy@sibrica.com">privacy@sibrica.com</a><br>

    <br>
    <b>2. Cele przetwarzania danych</b><br>
    Dane osobowe przetwarzamy w celu:<br>
    - obsługi zapytań i kontaktu z klientami,<br>
    - przygotowania oraz realizacji usług informatycznych,<br>
    - zapewnienia bezpieczeństwa i prawidłowego działania serwisu,<br>
    - dochodzenia lub obrony przed roszczeniami,<br>
    - analizy ruchu na stronie po wyrażeniu zgody na cookies analityczne.<br>

    <br>
    <b>3. Podstawy prawne</b><br>
    Podstawami prawnymi przetwarzania danych są art. 6 ust. 1 lit. a, b oraz f RODO.<br>

    <br>
    <b>4. Kategorie danych</b><br>
    Możemy przetwarzać dane identyfikacyjne, kontaktowe oraz dane techniczne (np. logi serwera, adres IP, informacje o przeglądarce).<br>

    <br>
    <b>5. Odbiorcy danych</b><br>
    Odbiorcami danych mogą być podmioty wspierające utrzymanie infrastruktury IT, hostingu i bezpieczeństwa serwisu, wyłącznie w zakresie niezbędnym do realizacji celów przetwarzania.<br>
    Do analizy ruchu na stronie wykorzystujemy Google Analytics (Google Ireland Ltd.); w związku z tym dane mogą być przekazywane poza Europejski Obszar Gospodarczy (EOG) na podstawie zabezpieczeń przewidzianych w RODO.<br>

    <br>
    <b>6. Okres przechowywania danych</b><br>
    Dane przechowujemy przez okres niezbędny do realizacji celu przetwarzania, a następnie przez czas wynikający z obowiązujących przepisów prawa lub do czasu przedawnienia roszczeń.<br>

    <br>
    <b>7. Prawa osoby, której dane dotyczą</b><br>
    Przysługuje Ci prawo do dostępu do danych, ich sprostowania, usunięcia, ograniczenia przetwarzania, sprzeciwu oraz wniesienia skargi do Prezesa UODO.<br>

    <br>
    <b>8. Kontakt</b><br>
    W sprawach związanych z przetwarzaniem danych osobowych skontaktuj się pod adresem: <a href="mailto:privacy@sibrica.com">privacy@sibrica.com</a>.<br>

    <br>
    Szczegóły dotyczące cookies znajdziesz w <a routerLink="/polityka">Polityce prywatności</a>.<br>
    <br>
    </ng-template>
    </ng-template>
  </div>
  <div class="col-md-2"></div>
</div>